/** Spanish for the entities area (docs/conventions/i18n.md). Keys are the English copy, verbatim. */
export const esEntities: Readonly<Record<string, string>> = {
  // Categories
  Water: 'Agua',
  Food: 'Comida',
  Medication: 'Medicamentos',
  'First aid': 'Primeros auxilios',
  Hygiene: 'Higiene',
  'Power and batteries': 'Energía y pilas',
  Lighting: 'Iluminación',
  Communication: 'Comunicación',
  Tools: 'Herramientas',
  'Shelter and warmth': 'Refugio y abrigo',
  Clothing: 'Ropa',
  Documentation: 'Documentación',
  Money: 'Dinero',
  Other: 'Otros',
  // Document categories
  Identity: 'Identidad',
  Legal: 'Legal',
  Medical: 'Médico',
  Insurance: 'Seguros',
  'Home and property': 'Vivienda y propiedad',
  Finance: 'Finanzas',
  Vehicle: 'Vehículo',
  Manuals: 'Manuales',
  // Priorities
  High: 'Alta',
  Medium: 'Media',
  Low: 'Baja',
  // Tasks
  Action: 'Acción',
  Recommendation: 'Recomendación',
  'Periodic check': 'Revisión periódica',
  Pending: 'Pendiente',
  'In progress': 'En curso',
  Done: 'Hecha',
  Dismissed: 'Descartada',
  'Done. Next check: {date}': 'Hecha. Próxima revisión: {date}',
  'Task done': 'Tarea hecha',
  'Mark “{title}” as done': 'Marcar «{title}» como hecha',
  // Validation
  Required: 'Obligatorio',
  'Invalid date': 'Fecha no válida',
  'Check the highlighted fields': 'Revisa los campos marcados',
  'The record no longer exists': 'El registro ya no existe',
  // Attachments
  Files: 'Archivos',
  Add: 'Añadir',
  'Photos, PDFs or scans. They are kept on all your devices so you can see them offline.':
    'Fotos, PDFs o escaneos. Se guardan en todos vuestros dispositivos para verlos sin conexión.',
  'This file has not been downloaded to this device yet':
    'Este archivo aún no se ha descargado en este dispositivo',
  'Remove {name}': 'Quitar {name}',
  'Not on this device yet': 'Aún no está en este dispositivo',
  'Waiting to upload': 'Pendiente de subir',
  '{count} file': '{count} archivo',
  '{count} files': '{count} archivos',
  '{name}: could not be added (50 MB at most)': '{name}: no se pudo añadir (máximo 50 MB)',
  // Records
  'Created by {name} · {when}': 'Creado por {name} · {when}',
  'Changed by {name} · {when}': 'Modificado por {name} · {when}',
  'Changes saved on this device, waiting to be sent':
    'Cambios guardados en este dispositivo, pendientes de enviar',
  'Waiting to sync': 'Pendiente de sincronizar',
  Someone: 'Alguien',
  // Due dates
  'Expires {when}': 'Caduca {when}',
  'From {date}': 'Desde el {date}',
  'Due {when}': 'Vence {when}',
  'Needed {when}': 'Hace falta {when}',
  'Overdue · {when}': 'Vencida · {when}',
  'Was needed {when}': 'Hacía falta {when}',
  'Best before {when}': 'Preferente {when}',
  'Eat soon · {when}': 'Consumir pronto · {when}',
  'Replace {when}': 'Reponer {when}',
  'Shelf life ends {when}': 'Fin de vida útil {when}',
  'Expired · {when}': 'Caducado · {when}',
  'Replace (best before) · {when}': 'Reponer · {when}',
  'Replace now · {when}': 'Reponer ya · {when}',
  'Shelf life over · {when}': 'Vida útil agotada · {when}',
  // Inventory and shopping
  'Low stock': 'Stock bajo',
  'Not estimated': 'Sin estimar',
};
